import { apiGet } from "./http";

export interface PointLedgerRow {
  id: string;
  delta: number;
  balanceAfter: number;
  category: string;
  memo: string;
  relatedActivityLegacyId?: string | null;
  date: string;
  createdAt: string;
}

export function fetchPointLedger(tenantLegacyId: string, memberLegacyId: string, take = 100) {
  return apiGet<PointLedgerRow[]>(
    `/api/tenants/${tenantLegacyId}/members/${encodeURIComponent(memberLegacyId)}/point-ledger?take=${take}`
  );
}
